var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaunch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    fill: "currentColor",
    className: "w-6 h-6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m466.1,385.6l-38-38.3c-8-8-7.9-20.9 0.1-28.9 8-8 20.9-7.9 28.9,0.1l38,38.3c8,8 7.9,20.9-0.1,28.9-4,4-16,11.8-28.9-0.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m436.8,208.7l-118.5-21.8-77.9-78.4c-55.5-55.8-128.7-97.4-207.1-97.4-7.5,5.32907e-15-24.1,4.4-21.9,24.8 7.9,72 42.7,146.3 96,199.9l81.1,81.5 21.7,119.2c7.7,22.9 27.5,18.3 34.6,10.7l202.9-204.1c7.8-6.6 10.3-28.7-10.9-34.4zm-193.5,182l-15.8-87c-0.7-4.1-2.7-7.8-5.6-10.7l-85.5-86c-41.1-41.4-69.2-94.5-80.6-151.6 58.7,10.7 113.3,39.3 155.7,82l82.4,82.9c2.9,3 6.7,4.9 10.8,5.7l86.7,16-148.1,148.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m495.1,356.8l-38-38.3c-7.9-8-20.9-8-28.9-0.1-8,7.9-8,20.9-0.1,28.9l38,38.3c12.9,11.8 24.9,4 28.9,0.1 8-7.9 8-20.9 0.1-28.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m348.1,427.5c-7.9-8-20.9-8-28.9-0.1-8,7.9-8,20.9-0.1,28.9l38,38.3c12.9,11.8 24.9,4 28.9,0.1 8-7.9 8-20.9 0.1-28.9l-38-38.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m402.6,373c-7.9-8-20.9-8-28.9-0.1-8,7.9-8,20.9-0.1,28.9l38,38.3c12.9,11.8 24.9,4 28.9,0.1 8-7.9 8-20.9 0.1-28.9l-38-38.3z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaunch);
export default __webpack_public_path__ + "static/media/launch.9787b0d2.svg";
export { ForwardRef as ReactComponent };